<template>
    <div class="poster">
        <div class="title">
            <p>产权管理</p>
        </div>
        <div class="main">
            <div class="form">
                <el-form :inline="true" :model="formInline" class="demo-form-inline">
                    <el-form-item>
                        <el-input v-model="formInline.id" placeholder="请输入编号ID" clearable></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-input v-model="formInline.name" placeholder="请输入品牌名称" clearable></el-input>
                    </el-form-item>
                    <el-form-item style="float: right">
                        <el-button type="primary" @click="onSubmit">查 询</el-button>
                        <el-button @click="reset">重 置</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </div>
        <div class="main table">
            <div class="tabs">
                <div class="btnlist">
                    <el-button type="primary" size="medium" @click="create">+ 添加</el-button>
                </div>
            </div>
            <div class="table">
                <el-table :data="tableData" style="width: 100%" v-loading="tabload">
                    <el-table-column prop="id" label="编号ID" align="center" width="80px"> </el-table-column>
                    <el-table-column prop="name" label="品牌名称" align="center"> </el-table-column>
                    <el-table-column prop="property_list" label="内容" align="center">
                        <template slot-scope="scope">
                            {{ scope.row.property_list | getTitle }}
                        </template>
                    </el-table-column>
                    <el-table-column prop="update_time" label="近期操作时间" align="center"> </el-table-column>
                    <el-table-column prop="is_open" label="状态" align="center">
                        <template slot-scope="scope">
                            {{ scope.row.is_open == 0 ? "关闭" : "开启" }}
                        </template>
                    </el-table-column>
                    <el-table-column prop="opt" label="操作" align="center" fixed="right" width="260px">
                        <template slot-scope="scope">
                            <div class="link">
                                <el-link :type="scope.row.is_open == 0 ? 'primary' : 'danger'" @click="operate(scope.row.id, scope.row.is_open)">{{
                                    scope.row.is_open == 0 ? "开启监控" : "关闭监控"
                                }}</el-link>
                                <el-link type="primary" @click="detail(scope.row.id)">详情</el-link>
                                <el-link type="primary" @click="edit(scope.row.id)">编辑</el-link>
                                <el-link type="primary" @click="deleteItem(scope.row.id)">删除</el-link>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="pageList">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="page"
                    :page-sizes="[10, 20, 30, 40]"
                    :page-size="size"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="total"
                    background
                >
                </el-pagination>
            </div>
        </div>
        <Detail ref="refDetail"></Detail>
        <CreateOrEdit ref="refCreateOrEdit" @init="getList(1)" :_type="type"></CreateOrEdit>
    </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import CreateOrEdit from "@/components/Modules/PropertyManagement/CreateOrEdit.vue";
import Detail from "@/components/Modules/PropertyManagement/Detail.vue";
export default {
    components: {
        Detail,
        CreateOrEdit,
    },
    filters: {
        getTitle(val) {
            if (!!val && val.length > 0) {
                let str = "";
                val.forEach((item) => {
                    str += item.title + "、";
                });
                str = str.substring(0, str.length - 1);
                return str;
            }
            return "-";
        },
    },
    data() {
        return {
            tabload: false,
            page: 1,
            size: 10,
            total: 0,
            tableData: [],
            formInline: {
                id: "",
                name: "",
            },
            type: "",
        };
    },
    computed: {
        ...mapGetters(["getToken"]),
    },
    created() {
        this.getList(1);
    },
    methods: {
        ...mapActions({
            getBrandList: "brand/getBrandList",
            deleteBrand: "brand/deleteBrand",
            updateStatusBrand: "brand/updateStatusBrand",
        }),
        deleteItem(id) {
            this.$confirm("此操作将删除该数据, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    let opt = {
                        token: this.getToken,
                        id: id,
                    };
                    this.deleteBrand(opt).then((res) => {
                        if (res.data.code == 1) {
                            this.$message.success("删除成功！");
                            this.getList();
                        } else {
                            this.$message.error(res.data.msg);
                        }
                    });
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消删除",
                    });
                });
        },
        create() {
            this.type = "create";
            this.$refs.refCreateOrEdit.dialogVisible = true;
        },
        edit(id) {
            this.type = "edit";
            this.$refs.refCreateOrEdit.dialogVisible = true;
            this.$refs.refCreateOrEdit.getTable(id);
        },
        postInfo(row) {
            console.log(row);
            this.$refs.refPostPoster.dialogVisible = true;
            this.$refs.refPostPoster.rowData = row;
        },
        operate(id, status) {
            let opt = {
                token: this.getToken,
                id: id,
                is_open: status == 0 ? 1 : 0,
            };
            this.updateStatusBrand(opt).then((res) => {
                if (res.data.code == 1) {
                    this.$message.success("修改成功！");
                    this.getList();
                } else {
                    this.$message.error(res.data.msg);
                }
            });
        },
        detail(id) {
            this.$refs.refDetail.dialogVisible = true;
            this.$refs.refDetail.getTable(id);
        },
        getList(tag) {
            this.tabload = true;
            let opt = {
                token: this.getToken,
                id: this.formInline.id,
                name: this.formInline.name, //输入的数据
                size: this.size, //页大小
                page: tag == 1 ? 1 : this.page, //页数
            };
            this.getBrandList(opt).then((res) => {
                this.tabload = false;
                if (res.data.code == 1) {
                    this.tableData = res.data.data.list;
                    this.total = res.data.data.count ? res.data.data.count : 0;
                } else {
                    this.$message.error(res.data.msg);
                }
            });
        },
        handleSizeChange(val) {
            this.size = val;
            this.getList();
        },
        handleCurrentChange(val) {
            this.page = val;
            this.getList();
        },
        onSubmit() {
            this.getList(1);
        },
        reset() {
            this.formInline = {
                id: "",
                name: "",
            };
            this.getList(1);
        },
    },
};
</script>
<style lang="scss" scoped>
.poster {
    position: relative;
    height: 100%;
    .table {
        padding: 20px 0;
    }
    ::v-deep .el-tabs__active-bar {
        width: 120px;
    }

    ::v-deep .el-tabs__item {
        width: 120px;
        text-align: center;
        padding: 0;
    }

    .title {
    box-shadow: 0px 0px 8px 0px rgb(100 100 100 / 17%);
        width: 100%;
        background: #fff;
        padding: 15px 32px;
        display: flex;
        align-items: center;

        p {
            font-size: 16px;
            color: #333;
            margin-left: 32px;

            span {
                color: #e72f0d;
                padding: 0 5px;
            }

            &:first-child {
                font-size: 18px;
                color: #333;
                margin-left: 0;
            }

            &:nth-child(2) {
                span {
                    color: #2448ff;
                }
            }
        }
    }
    .main.table {
        min-width: 1200px;
        min-height: 600px;
        .table {
            min-height: 500px;
        }
    }
    .main {
        min-width: 1200px;
        box-shadow: 0px 0px 8px 0px rgba(100, 100, 100, 0.17);
        background: #fff;
        margin: 24px;
        padding: 24px;
        ::v-deep .el-form-item {
            margin-bottom: 0;
        }
        .tabs {
            position: relative;
        }
        .btnlist {
            float: right;
            margin-bottom: 22px;
        }
        span {
            margin-right: 10px;

            ::v-deep .el-input {
                width: 150px;
                display: inline-block;
            }
        }

        ::v-deep .el-table th {
            background: #fafafa;
            padding: 10px 0;
        }
    }
}
.pageList {
    text-align: right;
    margin-top: 20px;
}
.link {
    a {
        margin: 0 12px;
    }
}
</style>